<mat-card class="information-fuses-card" >
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image"><mat-icon aria-hidden="false" aria-label="home icon">health_and_safety</mat-icon></div>
    <mat-card-title>Fuse  </mat-card-title>
    <mat-card-subtitle>  Raw: {{ information.fuse }}  </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item >
        <div *ngIf="information.fuse12DC">
          <span class="material-icons">check_circle</span>
          <span class="material-icons">toggle_on</span>
        </div>
        <div *ngIf="!information.fuse12DC">
          <mat-icon class="material-icons color_alert">warning</mat-icon>
          <span class="material-icons">toggle_off</span>
        </div>
        <div mat-line>  12V=</div>
      </mat-list-item>

      <mat-list-item >
        <div *ngIf="information.fuse24AC">
          <span class="material-icons">check_circle</span>
          <span class="material-icons">toggle_on</span>

        </div>
        <div *ngIf="!information.fuse24AC">
          <mat-icon  class="material-icons color_alert">warning</mat-icon>
          <span class="material-icons">toggle_off</span>
        </div>
        <div mat-line>  24V~</div>
      </mat-list-item>

      <mat-list-item >
        <div *ngIf="information.fuse24DC">
          <span class="material-icons">check_circle</span>
          <span class="material-icons">toggle_on</span>

        </div>
        <div *ngIf="!information.fuse24DC">
          <mat-icon class="material-icons color_alert">warning</mat-icon>
          <span class="material-icons">toggle_off</span>
        </div>

        <div mat-line>  24V=</div>
      </mat-list-item>

      <mat-list-item >
        <div *ngIf="information.fuse40DC">
          <span class="material-icons">check_circle</span>
          <span class="material-icons">toggle_on</span>
        </div>
        <div *ngIf="!information.fuse40DC">
          <mat-icon  class="material-icons color_alert">warning</mat-icon>
          <span class="material-icons">toggle_off</span>
        </div>
        <div mat-line>  40V=</div>
      </mat-list-item>

      <mat-list-item >
        <div *ngIf="information.board_voltage">
          {{ information.board_voltage }} Volt
        </div>
        <div mat-line>  CPU Voltage </div>
      </mat-list-item>

      <mat-list-item >
        <div *ngIf="information.board_temperature">
          {{ information.board_temperature }} °C
        </div>
         <div mat-line>  CPU board temperature</div>
      </mat-list-item>

    </mat-list>

  </mat-card-content>
</mat-card>

